import { SvgIcon } from '@material-ui/core';
import React from 'react';

export default function DocsIcon({ styles }: { styles?: React.CSSProperties }) {
  return (
    <SvgIcon
      width="28"
      height="23"
      viewBox="0 0 28 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={styles}
    >
      <path
        d="M11.2776 0.77771H3.11089C1.61367 0.77771 0.402283 2.00271 0.402283 3.49993L0.388672 19.8333C0.388672 21.3305 1.61367 22.5555 3.11089 22.5555H24.8887C26.3859 22.5555 27.6109 21.3305 27.6109 19.8333V6.22216C27.6109 4.72493 26.3859 3.49993 24.8887 3.49993H13.9998L11.2776 0.77771Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
